import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AgentService {
  is_display_agent_register_component = false;
  agentUpdate = new EventEmitter<Agent>();
  getHistory = new EventEmitter<boolean>();
  downloadAgent = new EventEmitter<boolean>();
  private _booth_data = null;
  private _agent_data: Agent = null;

  constructor() { }

  set set_agent_data(agent) {
    this._agent_data = agent;
  }

  get get_agent_data() {
    return this._agent_data;
  }

  set set_booth_data(booth) {
    this._booth_data = booth;
  }


  get get_booth_data() {
    return this._booth_data;
  }

}

export interface Agent {
  id: number;
  first_name: string;
}
